package com.oscarherreros.appcalculo.web

import kotlin.js.Date
import kotlin.js.dateLocaleOptions

private const val MILLIS_PER_DAY = 86_400_000.0

/**
 * El día [day] del mes [month] (de 1 a 12) de [year], contado como en la app:
 * días desde el 1 de enero de 1970.
 */
fun epochDay(year: Int, month: Int, day: Int): Long = (Date.UTC(year, month - 1, day) / MILLIS_PER_DAY).toLong()

/**
 * Hoy en la zona horaria del jugador, como `LocalDate.now().toEpochDay()` en la
 * app: así el reto del día es el mismo en los dos sitios.
 */
fun today(): Long {
    val now = Date()
    return epochDay(now.getFullYear(), now.getMonth() + 1, now.getDate())
}

/**
 * La fecha de [day] escrita en el idioma [locale], para el encabezado. Sin el
 * día de la semana, que con el número del reto sobra y alarga la línea.
 */
fun formatDay(day: Long, locale: String): String {
    val options = dateLocaleOptions {
        timeZone = "UTC"
        year = "numeric"
        month = "long"
        this.day = "numeric"
    }
    return Date(day * MILLIS_PER_DAY).toLocaleDateString(locale, options)
}
